import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgPriorityUrgent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.25 16.75L9.25 10.6225L6.5575 13.3075L5.5 12.25L10 7.75L14.5 12.25L13.4425 13.3075L10.75 10.6225L10.75 16.75H9.25Z",
		fill: "inherit"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.99717 3.23291L8.93439 4.29569L8.94043 4.30173L5.5 7.74216L6.56278 8.80494L10.0032 5.36452L13.4436 8.80493L14.5064 7.74215L11.066 4.30173L11.072 4.2957L10.0092 3.23292L10.0032 3.23895L9.99717 3.23291Z",
		fill: "inherit"
	})]
});
export default SvgPriorityUrgent;
